/* PetVault Local Assistant Engine — Pure Majesty Pets
   Rule-based pet health guide + product recommendations.
   Used by: snippets/petvault-chat.liquid and sections/petvault-landing.liquid.
   If window.PETVAULT_API_URL is set, callers may try the API first and
   fall back to PVAssistant.reply(message) when unavailable. */
(function () {
  'use strict';

  var CATALOG = {
    joints:     { name: 'Hip & Joint Chews (18 active ingredients)', price: '$45.99', url: '/products/dog-hip-and-joint-chews' },
    senior:     { name: 'Senior Dog Mobility Chews', price: '$39.99', url: '/products/senior-dog-mobility-chews' },
    glucosamine:{ name: 'Liquid Glucosamine Drops', price: '$24.99', url: '/products/liquid-glucosamine-for-dogs' },
    itch:       { name: 'Allergy Relief & Itchy Skin Chews', price: '$39.99', url: '/products/dog-itchy-skin-supplement' },
    yeast:      { name: 'Dog Yeast Infection Treatment Drops', price: '$21.99', url: '/products/dog-yeast-infection-treatment' },
    collagen:   { name: 'Liquid Collagen Drops', price: '$23.99', url: '/products/liquid-collagen-for-dogs' },
    dental:     { name: 'Dog Dental Powder (no brushing required)', price: '$44.99', url: '/products/dog-dental-powder' },
    ears:       { name: 'Vet-Strength Dog Ear Cleaner', price: '$24.99', url: '/products/dog-ear-cleaner' },
    eyes:       { name: 'Dog Eye Cleaning Rinse (tear stains)', price: '$19.99', url: '/products/dog-eye-cleaning-rinse' },
    vision:     { name: 'Advanced Vision Support Drops', price: '$29.99', url: '/products/advanced-vision-eye-support-for-dogs' },
    calm:       { name: 'Melatonin Calming & Sleep Drops', price: '$21.99', url: '/products/melatonin-for-dogs' },
    probiotic:  { name: 'Liquid Probiotic for Dogs & Cats', price: '$39.99', url: '/products/liquid-probiotic-for-dogs' },
    urinary:    { name: 'Cranberry Urinary & Bladder Drops', price: '$19.99', url: '/products/dog-cranberry-bladder-supplement' },
    immune:     { name: 'Dog Immune Support Drops', price: '$29.99', url: '/products/dog-immune-support-drops' },
    cough:      { name: 'Cough & Respiratory Support Drops', price: '$14.99', url: '/products/dog-cough-respiratory-drops' }
  };

  var EMERGENCY_TERMS = ['bloat', 'seizure', 'seizing', 'collapse', 'collapsed', 'unconscious', 'poison', 'poisoned', 'chocolate', 'xylitol', 'grapes', 'raisin', 'antifreeze', 'not breathing', 'trouble breathing', "can't breathe", 'hit by car', 'blood in', 'bleeding heavily', 'bleeding a lot', 'swallowed', 'heatstroke', 'heat stroke', 'pale gums', 'blue gums', 'twisted stomach', 'rat poison', 'ibuprofen', 'tylenol', 'overdose'];

  /* Each intent: match keywords, a helpful answer, product keys, optional follow-up. */
  var INTENTS = [
    {
      keys: ['joint', 'limp', 'arthritis', 'mobility', 'stiff', 'hip', 'jump', 'stairs', 'lame'],
      answer: "Joint discomfort is very common, especially in larger breeds and seniors. What helps: keeping your dog lean (extra weight strains joints), short frequent walks instead of long ones, soft bedding, and a daily joint supplement with glucosamine, chondroitin and MSM. If the limping is sudden, severe, or your dog cries when touched, have a vet rule out injury.",
      products: ['joints', 'glucosamine'],
      followup: 'Is your dog a senior (7+ years)? Our Senior Mobility Chews are formulated for aging joints.'
    },
    {
      keys: ['senior', 'old dog', 'older dog', 'aging', 'slowing down'],
      answer: "Senior dogs benefit from a few simple adjustments: twice-yearly vet checkups, joint support, shorter but regular exercise, mental stimulation, and watching weight closely. Senior-specific supplements support mobility, cognition and vitality.",
      products: ['senior', 'vision'],
      followup: 'You can track weight, meds and vet visits for your senior dog in My PetVault.'
    },
    {
      keys: ['itch', 'scratch', 'allerg', 'skin', 'hot spot', 'rash', 'red skin', 'biting paws', 'chewing paws'],
      answer: "Constant itching usually points to allergies (environmental or food), fleas, or a yeast/bacterial skin issue. Quick wins: regular flea prevention, weekly baths with a gentle dog shampoo, wiping paws after walks, and an omega-3 / skin-support supplement. If you see open sores, hair loss patches, or a bad smell, see your vet.",
      products: ['itch', 'collagen'],
      followup: 'Is the itching focused on paws and ears with a musty smell? That can be yeast — ask me about yeast.'
    },
    {
      keys: ['yeast', 'musty', 'smelly paws', 'brown paws', 'licking paws'],
      answer: "Yeast overgrowth shows up as a musty smell, rust-brown staining on paws, recurring ear gunk and non-stop licking. It thrives on moisture and sugar: dry paws and ears after water, consider a low-carb diet, and use a targeted anti-yeast topical. Persistent or spreading cases deserve a vet skin scrape to confirm.",
      products: ['yeast', 'ears'],
      followup: null
    },
    {
      keys: ['ear', 'head shaking', 'head shake', 'ear wax', 'ear smell', 'ear infection'],
      answer: "Head shaking, scratching at ears, dark wax or odor usually mean the ears need attention. A vet-strength ear cleaner used 1-2x per week dissolves wax and keeps the canal dry (floppy-eared breeds need it most). If the ear is red, painful, swollen, or there's discharge, that's likely an infection — see your vet for medicated drops.",
      products: ['ears'],
      followup: null
    },
    {
      keys: ['teeth', 'dental', 'breath', 'tartar', 'plaque', 'gum'],
      answer: "By age 3, most dogs already have dental disease — and bad breath is the first sign. Daily options ranked by effectiveness: tooth brushing, dental powder added to food (easiest for most owners), dental chews, and annual vet cleanings. Bleeding gums, loose teeth or refusing food warrant a vet dental exam.",
      products: ['dental'],
      followup: null
    },
    {
      keys: ['eye', 'tear stain', 'gunk', 'discharge', 'vision', 'cloudy', 'cataract'],
      answer: "For daily eye care and tear stains, a gentle eye rinse keeps the area clean (white and light-coated breeds need it most). For aging eyes — cloudiness, night hesitation, bumping into things — antioxidant vision support can help slow decline. Squinting, pawing at the eye, or a swollen/red eye is urgent: eyes can deteriorate fast, see a vet within 24h.",
      products: ['eyes', 'vision'],
      followup: null
    },
    {
      keys: ['anxi', 'stress', 'firework', 'thunder', 'separation', 'sleep', 'restless', 'pacing', 'barking at night', 'calm'],
      answer: "For anxiety and restlessness: build a predictable routine, give a safe den-like space, add daily physical + mental exercise, and try calming aids 30-60 minutes before known triggers (fireworks, car rides, being left alone). Melatonin-based drops help many dogs settle, especially at night. Sudden severe anxiety with other symptoms is worth a vet visit.",
      products: ['calm'],
      followup: 'Set medication and routine reminders in My PetVault so the whole family stays consistent.'
    },
    {
      keys: ['diarrhea', 'digest', 'gut', 'gas', 'stomach', 'vomit', 'soft stool', 'constipat', 'appetite'],
      answer: "For mild digestive upset: fast 12h (water always available), then small bland meals (boiled chicken + rice) for 2-3 days, and a daily probiotic to rebuild gut flora. See a vet promptly if there's blood, black tar-like stool, repeated vomiting, lethargy, or it lasts beyond 48h — puppies and seniors sooner.",
      products: ['probiotic'],
      followup: null
    },
    {
      keys: ['urinat', 'pee', 'bladder', 'uti', 'accident', 'urine'],
      answer: "Frequent small pees, straining, accidents indoors, or licking after urinating can signal urinary tract irritation. Encourage water intake, frequent potty breaks, and cranberry support for bladder-wall defense. Blood in urine, straining with nothing coming out (especially male dogs/cats), or crying while peeing is urgent — see a vet same day.",
      products: ['urinary'],
      followup: null
    },
    {
      keys: ['cough', 'kennel', 'wheez', 'sneez', 'respirat', 'honking'],
      answer: "A honking cough after boarding or dog parks is often kennel cough — usually self-limiting in 1-2 weeks: rest, humid air, and herbal respiratory support can soothe the throat. See a vet if your dog is also lethargic, off food, feverish, or the cough lasts over 2 weeks (or sooner for puppies, seniors, flat-faced breeds).",
      products: ['cough', 'immune'],
      followup: null
    },
    {
      keys: ['immune', 'sick often', 'recover', 'vitality', 'energy', 'tired', 'letharg'],
      answer: "Low energy can be as simple as age or diet — or an early sign of illness. Support the basics: quality protein-rich food, regular exercise, good sleep, and an immune-support supplement with antioxidants. If lethargy is sudden, severe, or paired with appetite loss, vomiting or fever, get a vet check.",
      products: ['immune'],
      followup: null
    },
    {
      keys: ['coat', 'shed', 'fur', 'hair loss', 'dull coat', 'collagen'],
      answer: "A dull coat and heavy shedding usually respond well to nutrition: omega-rich food, regular brushing (removes dead undercoat), and hydrolyzed collagen which supports skin, coat and joints from within. Bald patches, scabs or itching alongside hair loss point to a skin condition — vet time.",
      products: ['collagen', 'itch'],
      followup: null
    },
    {
      keys: ['vaccine', 'vaccin', 'shot', 'rabies', 'booster'],
      answer: "Core dog vaccines: rabies, distemper, parvovirus, adenovirus — typically boosted every 1-3 years depending on local rules and vaccine type. Lifestyle vaccines (bordetella, leptospirosis, Lyme) depend on where you live and what your dog does. Your vet sets the exact schedule.",
      products: [],
      followup: 'Tip: log every vaccine in My PetVault and it will remind you before the next one is due.'
    },
    {
      keys: ['puppy', 'kitten', 'new dog', 'new pet', 'adopt'],
      answer: "Congrats on the new family member! First 30 days: vet visit within the first week, start the vaccine series, parasite prevention, begin gentle socialization, and set routines early (potty, crate, alone-time). Create their profile in My PetVault so every record starts in one place.",
      products: ['probiotic'],
      followup: null
    },
    {
      keys: ['food', 'diet', 'nutrition', 'feed', 'weight', 'obese', 'fat'],
      answer: "General feeding rules: measure meals (don't free-feed), feed for your dog's target weight not current weight, treats under 10% of daily calories, and transition foods over 7 days to avoid stomach upset. You should feel ribs easily but not see them. Your vet can give a body-condition score and target weight.",
      products: ['probiotic'],
      followup: null
    },
    {
      keys: ['product', 'supplement', 'recommend', 'what do you sell', 'shop', 'catalog', 'buy'],
      answer: "Pure Majesty Pets makes vet-formulated supplements for the most common dog health needs: joints & mobility, skin & itch relief, dental, ears, eyes, calming, digestion, urinary, immunity and collagen. Tell me what your pet struggles with and I'll point you to the right one — or browse everything in the shop.",
      products: ['joints', 'itch', 'collagen'],
      followup: null
    }
  ];

  var GREETINGS = ['hi', 'hello', 'hey', 'bonjour', 'salut', 'good morning', 'good evening'];

  function norm(s) { return (s || '').toLowerCase(); }

  function isEmergency(msg) {
    var m = norm(msg);
    for (var i = 0; i < EMERGENCY_TERMS.length; i++) {
      if (m.indexOf(EMERGENCY_TERMS[i]) !== -1) return true;
    }
    return false;
  }

  function matchIntent(msg) {
    var m = norm(msg);
    var best = null, bestScore = 0;
    for (var i = 0; i < INTENTS.length; i++) {
      var score = 0;
      for (var k = 0; k < INTENTS[i].keys.length; k++) {
        if (m.indexOf(INTENTS[i].keys[k]) !== -1) score++;
      }
      if (score > bestScore) { bestScore = score; best = INTENTS[i]; }
    }
    return best;
  }

  /* Returns { text, products: [{name,price,url}], links: [{label,url}], emergency: bool } */
  function reply(message) {
    var m = norm(message).trim();

    if (isEmergency(m)) {
      return {
        emergency: true,
        text: "This sounds like it could be an emergency. Please don't wait — contact a veterinarian or an emergency animal hospital right now. Call ahead so they can prepare for your arrival. If a toxin is involved, you can also call the ASPCA Animal Poison Control Center at (888) 426-4435 (fees may apply).",
        products: [],
        links: [{ label: 'Find an emergency vet near you', url: '/pages/find-a-vet' }]
      };
    }

    var isGreeting = false;
    for (var i = 0; i < GREETINGS.length; i++) {
      if (m === GREETINGS[i] || m.indexOf(GREETINGS[i] + ' ') === 0 || m.indexOf(GREETINGS[i] + '!') === 0) { isGreeting = true; break; }
    }
    if (isGreeting || m.length < 3) {
      return {
        emergency: false,
        text: "Hello! I'm the PetVault assistant by Pure Majesty Pets. I can help with common pet health topics — itchy skin, joints, dental care, anxiety, digestion, ears, eyes and more. What's going on with your pet?",
        products: [],
        links: []
      };
    }

    var intent = matchIntent(m);
    if (intent) {
      var prods = [];
      for (var p = 0; p < intent.products.length; p++) {
        var item = CATALOG[intent.products[p]];
        if (item) prods.push(item);
      }
      var text = intent.answer + (intent.followup ? '\n\n' + intent.followup : '');
      return { emergency: false, text: text, products: prods, links: [] };
    }

    return {
      emergency: false,
      text: "I can help best with everyday pet health topics: itchy skin & allergies, joints & mobility, dental care, ears, eyes & tear stains, anxiety & sleep, digestion, urinary health, coughs, coat & shedding, vaccines, and choosing the right supplement. Try asking about one of those — or for anything specific to your pet's condition, your veterinarian is the right call.",
      products: [],
      links: [{ label: 'Browse all supplements', url: '/collections/all' }, { label: 'Find a vet near you', url: '/pages/find-a-vet' }]
    };
  }

  var QUICK_ACTIONS = [
    { label: 'My dog is itchy', message: 'My dog keeps scratching and itching' },
    { label: 'Joint & mobility help', message: 'My dog has stiff joints and trouble with stairs' },
    { label: 'Bad breath / dental', message: 'My dog has bad breath and tartar' },
    { label: 'Anxiety & sleep', message: 'My dog is anxious and restless at night' },
    { label: 'Which supplement?', message: 'Which supplement do you recommend for my dog?' }
  ];

  window.PVAssistant = { reply: reply, quickActions: QUICK_ACTIONS, catalog: CATALOG, isEmergency: isEmergency };
})();
